import hashTable from "./HashTable"
import BadTicketPositiveResponsesTypes from "../types/BadTicketPositiveResponsesTypes"
import TableIdentifierTypes from "../types/TableIdentifierTypes"
import ReferenceTypes from "src/store/UserReference/types"
import PositiveResponseService from "./PositiveResponseService"

const utilityReferenceTable = new hashTable(500)
const btprTable = new hashTable(500)

const PositiveResponseHashService = {
    buildBTPRTable: (btprs: BadTicketPositiveResponsesTypes[]) => {
        PositiveResponseHashService.purgeHashTable("btprTable")
        const newBTPRS = JSON.parse(JSON.stringify(btprs))
        for (let i = 0; i < newBTPRS.length; i++) {
            const btpr: BadTicketPositiveResponsesTypes = newBTPRS[i]
            btprTable.addItem([`${btpr.TicketPositiveResponseId}`, btpr, { checked: false }])
        }
        return btprTable
    },
    buildUtilityReferenceTable: (reference: ReferenceTypes) => {
        if (reference) {
            const utilities = reference.Utilities
            for (let i = 0; i < utilities.length; i++) {
                const utility = utilities[i]
                utilityReferenceTable.addItem([`${utility.UtilityID}`, utility])
            }
        }
        // console.log(utilityReferenceTable.getStorage())
        return utilityReferenceTable
    },
    getTableByIdentifier: (tableIdentifier: "utilityReferenceTable" | "btprTable") => {
        const table = tableIdentifier === "utilityReferenceTable" ? utilityReferenceTable : btprTable
        return table
    },
    purgeHashTable: (tableIdentifier: TableIdentifierTypes) => {
        PositiveResponseHashService.getTableByIdentifier(tableIdentifier).purgeTable(false)
    },
    lookupHashTableItem: (tableIdentifier: TableIdentifierTypes, id: number, debug?: boolean) => {
        const item = PositiveResponseHashService.getTableByIdentifier(tableIdentifier).lookupItem([`${id}`])
        if (debug) {
            //console.log("lookupHashTableItem debug", tableIdentifier, id, item)
        }
        return item
    },
    updateHashTableItem: (tableIdentifier: TableIdentifierTypes, bucketItem: any) => {
        PositiveResponseHashService.getTableByIdentifier(tableIdentifier).updateItem(bucketItem)
    },
    addHashTableItem: (tableIdentifier: TableIdentifierTypes, bucketItem: any) => {
        PositiveResponseHashService.getTableByIdentifier(tableIdentifier).addItem(bucketItem)
    },
    deleteHashTableItem: (tableIdentifier: TableIdentifierTypes, bucketItem: any) => {
        PositiveResponseHashService.getTableByIdentifier(tableIdentifier).deleteItem(bucketItem[0])
    },
    getHashTableStorage: (tableIdentifier: TableIdentifierTypes) => {
        return PositiveResponseHashService.getTableByIdentifier(tableIdentifier).getStorage()
    },
    checkIfAddIsDirty: () => {
        const { lookupHashTableItem } = PositiveResponseHashService
        const { badTicketPositiveResponses } = PositiveResponseService.state
        for (let i = 0; i < badTicketPositiveResponses.length; i++) {
            const btpr = badTicketPositiveResponses[i]
            //@ts-ignore
            const bucketItem = lookupHashTableItem("btprTable", btpr.TicketPositiveResponseId)
            if (bucketItem && bucketItem[2].checked) {
                return true
            }
        }
        return false
    },
    getBatch: () => {
        let batch = []
        const { lookupHashTableItem } = PositiveResponseHashService
        const { badTicketPositiveResponses } = PositiveResponseService.state
        for (let i = 0; i < badTicketPositiveResponses.length; i++) {
            const btpr: BadTicketPositiveResponsesTypes = badTicketPositiveResponses[i]
            //@ts-ignore
            const bucketItem = lookupHashTableItem("btprTable", btpr.TicketPositiveResponseId)
            if (bucketItem && bucketItem[2].checked) {
                batch.push(btpr.TicketPositiveResponseId)
            }
        }
        return batch
    },
    checkOrUncheckAll: () => {
        const { state, manageState } = PositiveResponseService
        const { badTicketPositiveResponses, allChecked } = state
        const {lookupHashTableItem, updateHashTableItem} = PositiveResponseHashService
        for (let i = 0; i < badTicketPositiveResponses.length; i++) {
            let btpr = badTicketPositiveResponses[i]
            //@ts-ignore
            let bucketItem = lookupHashTableItem("btprTable", btpr.TicketPositiveResponseId)
            if(bucketItem){
                bucketItem[2].checked = !allChecked
                updateHashTableItem("btprTable", bucketItem)
            }
        }
        manageState([{key: "allChecked", value: !allChecked}])
    }
}

export default PositiveResponseHashService